<template>
  <div class="about-us">
    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="main-content">
      <!-- 顶部大图 -->
      <section class="banner-section">
        <img src="@/assets/images/wenjpg.png" alt="服务范围" class="banner-image">
      </section>

      <!-- 行业活动精彩回顾板块ppt43 -->
      <section class="activity-review-section">
        <h2 class="section-title">{{ $t('hynews.texthy01') }}</h2>
        <div class="container">


          <!-- 第一行：单张图片 + 对应文字 -->
          <div class="activity-row-single">
            <div class="single-image-container">
              <img src="@/assets/images/news/hangye/anli01.png" alt="知识产权价值认识" class="activity-img">
            </div>
            <div class="single-text-container">
              <div class="activity-text">
                {{ $t('hynews.hynews02') }}
                <p v-show="$t('hynews.hynews02111')">{{ $t('hynews.hynews02111') }}</p>
                <strong>{{ $t('hynews.hynews03') }}</strong>{{ $t('hynews.hynews04') }}
              </div>
            </div>
          </div>

          <!-- 第二行：两张图片并排 -->
          <div class="activity-row-double">
            <div class="double-images-container">
              <div class="double-image-item">
                <img src="@/assets/images/news/hangye/anli02.png" alt="一带一路医学科技成果转化交流大会" class="activity-img">
              </div>
              <div class="double-image-item">
                <img src="@/assets/images/news/hangye/anli03.png" alt="高价值医学专利的三个半问题" class="activity-img">
              </div>
            </div>
            <div class="double-text-container">
              <div class="activity-text">
                 {{ $t('hynews.hynews05') }}<p> {{ $t('hynews.hynews05111') }}</p><strong> {{ $t('hynews.hynews06') }}</strong> {{ $t('hynews.hynews07') }}
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 行业活动精彩回顾板块ppt44 -->
      <section class="activity-showcase-section">
        <h2 class="section-title"> {{ $t('hynews.hynews08') }}</h2>
        <div class="container">

          <!-- 2023年9月活动 -->
          <div class="showcase-row">
            <div class="showcase-images-container">
              <div class="showcase-image-item">
                <img src="@/assets/images/news/hangye/anli04.png" alt="中华护理学会全国门诊护理学术交流会议" class="showcase-img">
              </div>
              <div class="showcase-image-item">
                <img src="@/assets/images/news/hangye/anli05.png" alt="中华护理学会颁奖仪式" class="showcase-img">
              </div>
            </div>
            <div class="showcase-text-container">
              <div class="showcase-text-content">
                <h3 class="showcase-title">{{ $t('hynews.hynews09') }}</h3>
                <p class="showcase-description">
                  {{ $t('hynews.hynews010') }}<strong> {{ $t('hynews.hynews011') }}</strong> {{ $t('hynews.hynews012') }}<strong> {{ $t('hynews.hynews013') }}</strong> {{ $t('hynews.hynews014') }}
                </p>
              </div>
            </div>
          </div>

          <!-- 2023年11月活动 -->
          <div class="showcase-row">
            <div class="showcase-text-container">
              <div class="showcase-text-content">
                <h3 class="showcase-title">{{ $t('hynews.hynews015') }}</h3>
                <div class="showcase-description">
                  {{ $t('hynews.hynews016') }}<p v-show="$t('hynews.hynews016111')"> {{ $t('hynews.hynews016111') }}</p><strong>{{ $t('hynews.hynews017') }}</strong>{{ $t('hynews.hynews018') }}<strong>{{ $t('hynews.hynews019') }}</strong>{{ $t('hynews.hynews020') }}
                </div>
              </div>
            </div>
            <div class="showcase-images-container">
              <div class="showcase-image-item">
                <img src="@/assets/images/news/hangye/anli06.png" alt="护理创新与转化会议" class="showcase-img">
              </div>
              <div class="showcase-image-item">
                <img src="@/assets/images/news/hangye/anli07.png" alt="广东省护理学会创新大赛" class="showcase-img">
              </div>
            </div>
          </div>

        </div>
      </section>
      <!-- 行业活动精彩回顾板块ppt45.56 -->
      <section class="training-academic-section">
        <h2 class="section-title">{{ $t('hynews.hynews021') }}</h2>
        <div class="container">

          <!-- 培训项目列表 -->
          <div class="training-list">
            <div class="training-item">
              <div class="training-number">1</div>
              <div class="training-content">
                <h3 class="training-title">{{ $t('hynews.hynews022') }}</h3>
                <p class="training-description">
                  {{ $t('hynews.hynews023') }}
                </p>
              </div>
            </div>

            <div class="training-item">
              <div class="training-number">2</div>
              <div class="training-content">
                <h3 class="training-title">{{ $t('hynews.hynews024') }}</h3>
                <p class="training-description">
                  {{ $t('hynews.hynews025') }}
                </p>
              </div>
            </div>

            <div class="training-item">
              <div class="training-number">3</div>
              <div class="training-content">
                <h3 class="training-title">{{ $t('hynews.hynews026') }}</h3>
                <p class="training-description">
                  {{ $t('hynews.hynews027') }}
                </p>
              </div>
            </div>

            <div class="training-item">
              <div class="training-number">4</div>
              <div class="training-content">
                <h3 class="training-title">{{ $t('hynews.hynews028') }}</h3>
                <p class="training-description">
                    {{ $t('hynews.hynews029') }}
                </p>
              </div>
            </div>

            <div class="training-item">
              <div class="training-number">5</div>
              <div class="training-content">
                <h3 class="training-title">{{ $t('hynews.hynews030') }}</h3>
                <p class="training-description">
                   {{ $t('hynews.hynews031') }}
                </p>
              </div>
            </div>

            <div class="training-item">
              <div class="training-number">6</div>
              <div class="training-content">
                <h3 class="training-title">{{ $t('hynews.hynews032') }}</h3>
                <p class="training-description">
                  {{ $t('hynews.hynews033') }}
                </p>
              </div>
            </div>


            <div class="training-item">
              <div class="training-number">7</div>
              <div class="training-content">
                <h3 class="training-title">{{ $t('hynews.hynews034') }}</h3>
                <p class="training-description">
                  {{ $t('hynews.hynews035') }}
                </p>
              </div>
            </div>


            <div class="training-item">
              <div class="training-number">8</div>
              <div class="training-content">
                <p class="training-description" style="margin-top: 0.6rem;">
                  {{ $t('hynews.hynews036') }}
                </p>
              </div>
            </div>

            <div class="training-item">
              <div class="training-number">9</div>
              <div class="training-content">
                <p class="training-description" style="margin-top: 0.6rem;">
                  {{ $t('hynews.hynews037') }}
                </p>
              </div>
            </div>


            <div class="training-item">
              <div class="training-number">10</div>
              <div class="training-content">
                <p class="training-description" style="margin-top: 0.6rem;">
                  {{ $t('hynews.hynews038') }}
                </p>
              </div>
            </div>

            <div class="training-item">
              <div class="training-number">11</div>
              <div class="training-content">
                <p class="training-description" style="margin-top: 0.6rem;">
                  {{ $t('hynews.hynews039') }}
                </p>
              </div>
            </div>

            <div class="training-item">
              <div class="training-number">12</div>
              <div class="training-content">
                <p class="training-description" style="margin-top: 0.6rem;">
                  {{ $t('hynews.hynews040') }}
                </p>
              </div>
            </div>

            <div class="training-item">
              <div class="training-number">13</div>
              <div class="training-content">
                <p class="training-description" style="margin-top: 0.6rem;">
                  {{ $t('hynews.hynews041') }}
                </p>
              </div>
            </div>

          </div>


          <!-- 学术交流现场图片 -->
          <div class="academic-gallery">
            <h3 class="gallery-title"> {{ $t('hynews.hynews042') }}</h3>
                 <div class="gallery-images" >
              <div class="gallery-image-item">
                <img src="@/assets/images/news/hangye/hyn1.jpg" alt="学术交流现场1" class="gallery-img">

              </div>
              <div class="gallery-image-item">
                <img src="@/assets/images/news/hangye/hyn2.jpg" alt="学术交流现场2" class="gallery-img">
              </div>

            </div>
            <div class="gallery-images" style="margin-top: 1.5rem;">
              <div class="gallery-image-item">
                <img src="@/assets/images/news/hangye/anli08.png" alt="学术交流现场1" class="gallery-img">

              </div>
              <div class="gallery-image-item">
                <img src="@/assets/images/news/hangye/anli09.png" alt="学术交流现场2" class="gallery-img">
              </div>

            </div>
       
            <div class="gallery-images" style="margin-top: 1.5rem;">
              <div class="gallery-image-item">
                <img src="@/assets/images/news/hangye/anli10.png" alt="学术交流现场1" class="gallery-img">

              </div>
              <div class="gallery-image-item">
                <img src="@/assets/images/news/hangye/anli11.png" alt="学术交流现场2" class="gallery-img">
              </div>
              <div class="gallery-image-item">
                <img src="@/assets/images/news/hangye/anli12.png" alt="学术交流现场2" class="gallery-img">
              </div>

            </div>
          </div>

        </div>
      </section>
      <!-- 行业活动精彩回顾板块ppt47 -->
      <section class="patent-training-section">
        <h2 class="section-title">{{ $t('hynews.hynews043') }}</h2>
        <div class="container">

          <div class="training-case-content">
            <!-- 左侧图片 -->
            <div class="case-image-container">
              <img src="@/assets/images/news/hangye/anli14.png" alt="电力行业科技创新及专利实操技能培训班" class="case-img"
                style="object-fit: contain;height:500px">
            </div>

            <!-- 右侧文字 -->
            <div class="case-text-container">
              <div class="case-text-content">
                <p class="case-description">
                 {{ $t('hynews.hynews044') }}<strong> {{ $t('hynews.hynews045') }}</strong> {{ $t('hynews.hynews046') }}
                </p>
                <div class="case-highlights">
                  <div class="highlight-item">
                    <div class="highlight-icon">📅</div>
                    <span class="highlight-text"> {{ $t('hynews.hynews047') }}</span>
                  </div>
                  <div class="highlight-item">
                    <div class="highlight-icon">👥</div>
                    <span class="highlight-text"> {{ $t('hynews.hynews048') }}</span>
                  </div>
                  <div class="highlight-item">
                    <div class="highlight-icon">🏢</div>
                    <span class="highlight-text"> {{ $t('hynews.hynews049') }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>
    </main>
    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'AboutUs',
  components: {
    Header,
    Footer
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped>
.about-us {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.main-content {
  min-height: 80vh;
}

/* 页面标题部分 */
.page-header {
  background-color: #FFF5F0;
  padding: 2rem 0;
  border-bottom: 1px solid #e9ecef;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
  text-align: center;
  color: #FF631E;
}

/* 新闻列表部分 */
.news-section {
  background-color: #FFF5F0;
  padding: 3rem 0;
}

.news-header {
  margin-bottom: 2rem;
}

.news-header .section-title {
  color: #FF631E;
  font-size: 1.8rem;
  font-weight: 600;
  text-align: center;
}

.news-content {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 2rem;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.news-item {
  padding: 0.8rem 0;
  border-bottom: 1px solid #eee;
}

.news-item:last-child {
  border-bottom: none;
}

.news-link {
  color: #333;
  text-decoration: none;
  font-size: 1rem;
  line-height: 1.5;
  transition: color 0.3s ease;
  display: block;
}

.news-link:hover {
  color: #FF631E;
}

/* 通用样式 */
.container {
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  padding: 4rem 1rem;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

/* PC端横向布局 */
@media (min-width: 769px) {
  .activity-review-section .container {
    flex-direction: row;
    gap: 0rem;
    align-items: flex-start;
  }
}

.section-title {
  font-size: 2.2rem;
  font-weight: 600;
  margin-bottom: 2rem;
  color: #333;
}

/* 关于我们内容样式 */
.about-content {
  padding: 4rem 0;
}

.about-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  align-items: center;
}

.about-image {
  flex: 1;
  min-width: 300px;
}

.about-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.about-text {
  flex: 1;
  min-width: 300px;
}

.about-paragraph {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #666;
}

/* 价值观部分样式 */
.values-section {
  background-color: #f8f9fa;
  padding: 4rem 0;
}

.values-section .section-title {
  text-align: center;
  margin-bottom: 3rem;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.value-card {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.value-card:hover {
  transform: translateY(-5px);
}

.value-icon {
  font-size: 2.5rem;
  color: #007bff;
  margin-bottom: 1.5rem;
}

.value-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.value-text {
  font-size: 1rem;
  line-height: 1.6;
  color: #666;
}

/* 顶部大图部分 */
.banner-section {
  width: 100%;
  height: 500px;
  overflow: hidden;
  position: relative;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 行业活动精彩回顾板块样式 */
.activity-review-section {
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
  padding: 4rem 0;
  position: relative;
}

.activity-review-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
}

.activity-review-section .section-title {
  text-align: center;
  color: #FF631E;
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 0rem;
  position: relative;
  text-shadow: 0 2px 4px rgba(255, 99, 30, 0.1);
}

.activity-review-section .section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(255, 99, 30, 0.3);
}

/* 第一行：单张图片布局 */
.activity-row-single {
  margin-bottom: 3rem;
  background: rgba(255, 255, 255, 0.9);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* PC端第一行横向布局 */
@media (min-width: 769px) {
  .activity-row-single {
    flex: 1;
    margin-bottom: 0;
    margin-right: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 500px;
  }

  .activity-row-single:last-child {
    margin-right: 0;
  }
}

.activity-row-single:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
  border-color: rgba(255, 99, 30, 0.2);
}

.single-image-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
}

.single-image-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255, 99, 30, 0.1), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
}

.single-image-container:hover::before {
  opacity: 1;
}

.single-image-container .activity-img {
  width: 350px;
  height: 240px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(255, 99, 30, 0.2);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.single-image-container:hover .activity-img {
  transform: scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 99, 30, 0.4);
}

.single-text-container {
  display: flex;
  justify-content: center;
}

.single-text-container .activity-text {
  max-width: 350px;
  font-size: 1rem;
  line-height: 1.7;
  color: #2c3e50;
  margin: 0;
  padding: 1.5rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 12px;
  border: 2px solid #FF631E;
  box-shadow: 0 4px 16px rgba(255, 99, 30, 0.1);
  position: relative;
  transition: all 0.3s ease;
}

.single-text-container .activity-text:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255, 99, 30, 0.15);
}



/* 第二行：双张图片布局 */
.activity-row-double {
  background: rgba(255, 255, 255, 0.9);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* PC端第二行横向布局 */
@media (min-width: 769px) {
  .activity-row-double {
    flex: 1;
    margin-left: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 500px;
  }
}

.activity-row-double:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
  border-color: rgba(255, 99, 30, 0.2);
}

.double-images-container {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 1.5rem;
}

.double-image-item {
  flex: 0 0 auto;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
}

.double-image-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255, 99, 30, 0.1), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
}

.double-image-item:hover::before {
  opacity: 1;
}

.double-image-item .activity-img {
  width: 350px;
  height: 240px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(255, 99, 30, 0.2);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.double-image-item:hover .activity-img {
  transform: scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 99, 30, 0.4);
}

.double-text-container {
  display: flex;
  justify-content: center;
}

.double-text-container .activity-text {
  max-width: 720px;
  font-size: 1rem;
  line-height: 1.7;
  color: #2c3e50;
  margin: 0;
  padding: 1.5rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 12px;
  border: 2px solid #FF631E;
  box-shadow: 0 4px 16px rgba(255, 99, 30, 0.1);
  position: relative;
  transition: all 0.3s ease;
  text-align: justify;
}

.double-text-container .activity-text:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255, 99, 30, 0.15);
}



.activity-text strong {
  color: #FF631E;
  font-weight: 700;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 1px 2px rgba(255, 99, 30, 0.1);
  position: relative;
}

.activity-text strong::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  border-radius: 1px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.activity-text:hover strong::after {
  opacity: 0.6;
}

/* 更多精彩活动展示板块样式 */
.activity-showcase-section {
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
  padding: 4rem 0;
  position: relative;
}

.activity-showcase-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
}

.activity-showcase-section .section-title {
  text-align: center;
  color: #FF631E;
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 3rem;
  position: relative;
  text-shadow: 0 2px 4px rgba(255, 99, 30, 0.1);
}

.activity-showcase-section .section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(255, 99, 30, 0.3);
}

/* 展示行样式 */
.showcase-row {
  display: flex;
  align-items: center;
  margin-bottom: 3rem;
  background: rgba(255, 255, 255, 0.95);
  padding: 2.5rem;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  gap: 3rem;
}

.showcase-row:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
  border-color: rgba(255, 99, 30, 0.2);
}

.showcase-row:nth-child(even) {
  flex-direction: row-reverse;
}

.showcase-row:last-child {
  margin-bottom: 0;
}

/* 图片容器样式 */
.showcase-images-container {
  flex: 1;
  display: flex;
  gap: 1.5rem;
  justify-content: center;
}

.showcase-image-item {
  flex: 1;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  max-width: 280px;
}

.showcase-image-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255, 99, 30, 0.15), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
}

.showcase-image-item:hover::before {
  opacity: 1;
}

.showcase-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 3px solid rgba(255, 99, 30, 0.2);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.showcase-image-item:hover .showcase-img {
  transform: scale(1.08);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 99, 30, 0.4);
}

/* 文本容器样式 */
.showcase-text-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.showcase-text-content {
  width: 100%;
  max-width: 500px;
  padding: 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  border: 3px solid #FF631E;
  box-shadow: 0 8px 32px rgba(255, 99, 30, 0.1);
  position: relative;
  transition: all 0.3s ease;
}

.showcase-text-content:hover {
  transform: translateY(-5px);
  box-shadow: 0 16px 48px rgba(255, 99, 30, 0.15);
}



.showcase-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #FF631E;
  margin-bottom: 1rem;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.showcase-title::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 60px;
  height: 3px;
  border-radius: 2px;
}

.showcase-description {
  font-size: 1rem;
  line-height: 1.8;
  color: #2c3e50;
  margin: 0;
  text-align: justify;
}

.showcase-description strong {
  color: #FF631E;
  font-weight: 700;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.showcase-description strong::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  border-radius: 1px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.showcase-description:hover strong::after {
  opacity: 0.6;
}

/* 专业培训与学术交流板块样式 */
.training-academic-section {
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
  padding: 4rem 0;
  position: relative;
}

.training-academic-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
}

.training-academic-section .section-title {
  text-align: center;
  color: #FF631E;
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 3rem;
  position: relative;
  text-shadow: 0 2px 4px rgba(255, 99, 30, 0.1);
}

.training-academic-section .section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(255, 99, 30, 0.3);
}

/* 培训列表样式 */
.training-list {
  margin-bottom: 4rem;
}

.training-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  background: rgba(255, 255, 255, 0.95);
  padding: 1rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  gap: 1.5rem;
}

.training-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
  border-color: rgba(255, 99, 30, 0.2);
}

.training-item:last-child {
  margin-bottom: 0;
}

/* 培训编号样式 */
.training-number {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 700;
  box-shadow: 0 4px 16px rgba(255, 99, 30, 0.3);
  position: relative;
}

.training-number::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  border-radius: 50%;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.training-item:hover .training-number::before {
  opacity: 0.3;
}

/* 培训内容样式 */
.training-content {
  flex: 1;
}

.training-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #FF631E;
  margin-bottom: 0.8rem;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.training-title::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 50px;
  height: 2px;
  border-radius: 1px;
}

.training-description {
  font-size: 1rem;
  line-height: 1.7;
  color: #2c3e50;
  margin: 0;
  text-align: justify;
}

.training-description strong {
  color: #FF631E;
  font-weight: 700;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.training-description strong::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 1px;
  border-radius: 1px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.training-description:hover strong::after {
  opacity: 0.6;
}

/* 学术交流图片画廊样式 */
.academic-gallery {
  background: rgba(255, 255, 255, 0.95);
  padding: 2.5rem;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.academic-gallery:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
  border-color: rgba(255, 99, 30, 0.2);
}

.gallery-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #FF631E;
  text-align: center;
  margin-bottom: 2rem;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.gallery-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  border-radius: 2px;
}

.gallery-images {
  display: flex;
  gap: 2rem;
  justify-content: center;
}

.gallery-image-item {
  flex: 1;
  max-width: 400px;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.gallery-image-item:hover {
  transform: scale(1.05);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
}

.gallery-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 16px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  padding: 2rem 1.5rem 1.5rem;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.gallery-image-item:hover .image-overlay {
  transform: translateY(0);
}

.overlay-text {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* 专利实操技能培训案例板块样式 */
.patent-training-section {
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
  padding: 4rem 0;
  position: relative;
}

.patent-training-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
}

.patent-training-section .section-title {
  text-align: center;
  color: #FF631E;
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 3rem;
  position: relative;
  text-shadow: 0 2px 4px rgba(255, 99, 30, 0.1);
}

.patent-training-section .section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(255, 99, 30, 0.3);
}

/* 培训案例内容容器 */
.training-case-content {
  display: flex;
  align-items: center;
  gap: 3rem;
  background: rgba(255, 255, 255, 0.95);
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.training-case-content:hover {
  transform: translateY(-8px);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.12);
  border-color: rgba(255, 99, 30, 0.2);
}

/* 左侧图片容器 */
.case-image-container {
  flex: 0 0 400px;
  position: relative;
  overflow: hidden;
}

.case-img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.case-image-container:hover .case-img {
  transform: scale(1.05);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.image-decoration {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  border-radius: 50%;
  opacity: 0.8;
  z-index: 1;
}

.image-decoration::before {
  content: '🎓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
}

/* 右侧文字容器 */
.case-text-container {
  flex: 1;
  display: flex;
  align-items: center;
}

.case-text-content {
  width: 100%;
}

.case-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #2c3e50;
  margin: 0 0 2rem 0;
  text-align: justify;
  padding: 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  border: 2px solid rgba(255, 99, 30, 0.1);
  box-shadow: 0 8px 32px rgba(255, 99, 30, 0.05);
  position: relative;
  transition: all 0.3s ease;
}

.case-description:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 48px rgba(255, 99, 30, 0.1);
  border-color: rgba(255, 99, 30, 0.2);
}

.case-description::before {
  content: '"';
  position: absolute;
  top: -10px;
  left: 20px;
  font-size: 3rem;
  color: #FF631E;
  font-family: serif;
  opacity: 0.3;
}

.case-description strong {
  color: #FF631E;
  font-weight: 700;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.case-description strong::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  border-radius: 1px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.case-description:hover strong::after {
  opacity: 0.6;
}

/* 亮点展示 */
.case-highlights {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.highlight-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  color: white;
  padding: 0.8rem 1.2rem;
  border-radius: 25px;
  box-shadow: 0 4px 16px rgba(255, 99, 30, 0.3);
  transition: all 0.3s ease;
  font-weight: 600;
}

.highlight-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255, 99, 30, 0.4);
}

.highlight-icon {
  font-size: 1.2rem;
}

.highlight-text {
  font-size: 0.9rem;
  white-space: nowrap;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 95%;
    max-width: 95%;
    padding: 3rem 1rem;
  }

  .banner-section {
    height: 600px;
  }
}

@media (max-width: 992px) {
  .values-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .banner-section {
    height: 500px;
  }

  .news-content {
    padding: 1.5rem;
  }

  .news-link {
    font-size: 0.95rem;
  }

  /* 行业活动板块响应式 */
  .activity-review-section {
    padding: 3rem 0;
  }

  .activity-review-section .section-title {
    font-size: 2rem;
    margin-bottom: 2.5rem;
  }

  .activity-row-single,
  .activity-row-double {
    padding: 1.5rem;
    margin-bottom: 2.5rem;
  }

  .single-image-container .activity-img,
  .double-image-item .activity-img {
    width: 300px;
    height: 200px;
  }

  .single-text-container .activity-text {
    max-width: 300px;
    font-size: 0.95rem;
    padding: 1.2rem;
  }

  .double-images-container {
    gap: 1.5rem;
  }

  .double-text-container .activity-text {
    max-width: 620px;
    font-size: 0.95rem;
    padding: 1.2rem;
  }

  /* 活动展示板块响应式 */
  .activity-showcase-section {
    padding: 3rem 0;
  }

  .activity-showcase-section .section-title {
    font-size: 2rem;
    margin-bottom: 2.5rem;
  }

  .showcase-row {
    padding: 2rem;
    gap: 2rem;
  }

  .showcase-img {
    height: 180px;
  }

  .showcase-text-content {
    padding: 1.5rem;
  }

  .showcase-title {
    font-size: 1.3rem;
  }

  .showcase-description {
    font-size: 0.95rem;
  }

  /* 培训学术板块响应式 */
  .training-academic-section {
    padding: 3rem 0;
  }

  .training-academic-section .section-title {
    font-size: 2rem;
    margin-bottom: 2.5rem;
  }

  .training-item {
    padding: 1.5rem;
    gap: 1rem;
  }

  .training-number {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }

  .training-title {
    font-size: 1.2rem;
  }

  .training-description {
    font-size: 0.95rem;
  }

  .academic-gallery {
    padding: 2rem;
  }

  .gallery-title {
    font-size: 1.3rem;
  }

  .gallery-images {
    gap: 1.5rem;
  }

  .gallery-img {
    height: 200px;
  }

  /* 专利培训案例板块响应式 */
  .patent-training-section {
    padding: 3rem 0;
  }

  .patent-training-section .section-title {
    font-size: 2rem;
    margin-bottom: 2.5rem;
  }

  .training-case-content {
    gap: 2rem;
    padding: 2rem;
  }

  .case-image-container {
    flex: 0 0 350px;
  }

  .case-img {
    height: 250px;
  }

  .image-decoration {
    width: 50px;
    height: 50px;
    top: -8px;
    right: -8px;
  }

  .image-decoration::before {
    font-size: 1.2rem;
  }

  .case-description {
    font-size: 1rem;
    padding: 1.5rem;
  }

  .case-highlights {
    gap: 1rem;
  }

  .highlight-item {
    padding: 0.6rem 1rem;
  }

  .highlight-text {
    font-size: 0.85rem;
  }
}

@media (max-width: 768px) {
  .about-wrapper {
    flex-direction: column;
  }

  .values-grid {
    grid-template-columns: 1fr;
  }

  .page-title {
    font-size: 2rem;
  }

  .section-title {
    font-size: 1.8rem;
  }

  .banner-section {
    height: 400px;
  }

  .news-section {
    padding: 2rem 0;
  }

  .news-header {
    margin-bottom: 1.5rem;
  }

  .container {
    width: 100%;
    max-width: 100%;
    padding: 2rem 0.5rem;
    margin: 0;
  }

  /* 行业活动板块平板响应式 */
  .activity-review-section {
    padding: 2.5rem 0;
  }

  .activity-review-section .section-title {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }

  .activity-row-single,
  .activity-row-double {
    padding: 1.2rem;
    margin-bottom: 2rem;
    border-radius: 12px;
  }

  .activity-row-single:hover,
  .activity-row-double:hover {
    transform: translateY(-4px);
  }

  .single-image-container .activity-img {
    width: 280px;
    height: 180px;
  }

  .single-text-container .activity-text {
    max-width: 280px;
    font-size: 0.9rem;
    padding: 1rem;
  }

  .double-images-container {
    gap: 1rem;
  }

  .double-image-item .activity-img {
    width: 250px;
    height: 160px;
  }

  .double-text-container .activity-text {
    max-width: 520px;
    font-size: 0.9rem;
    padding: 1rem;
  }

  .activity-row-single {
    margin-bottom: 2rem;
  }

  /* 活动展示板块平板响应式 */
  .activity-showcase-section {
    padding: 2.5rem 0;
  }

  .activity-showcase-section .section-title {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }

  .showcase-row {
    flex-direction: column !important;
    padding: 1.5rem;
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  .showcase-images-container {
    gap: 1rem;
  }

  .showcase-img {
    height: 160px;
  }

  .showcase-text-content {
    padding: 1.2rem;
    max-width: 100%;
  }

  .showcase-title {
    font-size: 1.2rem;
  }

  .showcase-description {
    font-size: 0.9rem;
    line-height: 1.6;
  }

  /* 培训学术板块平板响应式 */
  .training-academic-section {
    padding: 2.5rem 0;
  }

  .training-academic-section .section-title {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }

  .training-list {
    margin-bottom: 3rem;
  }

  .training-item {
    flex-direction: column;
    text-align: center;
    padding: 1.2rem;
    gap: 1rem;
  }

  .training-number {
    align-self: center;
    width: 45px;
    height: 45px;
    font-size: 1.1rem;
  }

  .training-title {
    font-size: 1.1rem;
    text-align: center;
  }

  .training-description {
    font-size: 0.9rem;
    line-height: 1.6;
    text-align: left;
  }

  .academic-gallery {
    padding: 1.5rem;
  }

  .gallery-title {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
  }

  .gallery-images {
    flex-direction: column;
    gap: 1rem;
  }

  .gallery-image-item {
    max-width: 100%;
  }

  .gallery-img {
    height: 180px;
  }

  /* 专利培训案例板块平板响应式 */
  .patent-training-section {
    padding: 2.5rem 0;
  }

  .patent-training-section .section-title {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }

  .training-case-content {
    flex-direction: column;
    gap: 2rem;
    padding: 1.5rem;
    text-align: center;
  }

  .case-image-container {
    flex: none;
    max-width: 400px;
    align-self: center;
  }

  .case-img {
    height: 220px;
  }

  .image-decoration {
    width: 45px;
    height: 45px;
    top: -6px;
    right: -6px;
  }

  .image-decoration::before {
    font-size: 1rem;
  }

  .case-text-container {
    width: 100%;
  }

  .case-description {
    font-size: 0.95rem;
    line-height: 1.7;
    padding: 1.2rem;
    text-align: left;
  }

  .case-description::before {
    font-size: 2.5rem;
    top: -8px;
    left: 15px;
  }

  .case-highlights {
    justify-content: center;
    gap: 0.8rem;
  }

  .highlight-item {
    padding: 0.6rem 1rem;
  }

  .highlight-text {
    font-size: 0.8rem;
  }
}

@media (max-width: 576px) {
  .about-us {
    min-width: 320px;
  }

  .page-title {
    font-size: 1.8rem;
  }

  .section-title {
    font-size: 1.6rem;
  }

  .banner-section {
    height: 300px;
  }

  .news-item {
    padding: 0.6rem 0;
  }

  .news-link {
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .news-content {
    padding: 1rem;
  }

  .container {
    width: 100%;
    max-width: 100%;
    padding: 1.5rem 0.5rem;
    margin: 0;
  }

  /* 行业活动板块手机端响应式 */
  .activity-review-section {
    padding: 2rem 0;
  }

  .activity-review-section .section-title {
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
  }

  .activity-review-section .section-title::after {
    width: 50px;
    height: 3px;
  }

  .activity-row-single,
  .activity-row-double {
    padding: 1rem;
    margin-bottom: 1.5rem;
    border-radius: 12px;
  }

  .activity-row-single:hover,
  .activity-row-double:hover {
    transform: translateY(-2px);
  }

  .single-image-container .activity-img {
    width: 280px;
    height: 180px;
    border-radius: 8px;
  }

  .single-text-container .activity-text {
    max-width: 280px;
    font-size: 0.9rem;
    padding: 1rem;
    border-radius: 8px;
  }

  .double-images-container {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .double-image-item .activity-img {
    width: 280px;
    height: 180px;
    border-radius: 8px;
  }

  .double-text-container .activity-text {
    max-width: 300px;
    font-size: 0.9rem;
    padding: 1rem;
    border-radius: 8px;
  }

  .activity-row-single {
    margin-bottom: 1.5rem;
  }

  .activity-row-double {
    margin-top: 1.5rem;
  }

  /* 活动展示板块手机端响应式 */
  .activity-showcase-section {
    padding: 2rem 0;
  }

  .activity-showcase-section .section-title {
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
  }

  .activity-showcase-section .section-title::after {
    width: 50px;
    height: 3px;
  }

  .showcase-row {
    flex-direction: column !important;
    padding: 1rem;
    gap: 1rem;
    margin-bottom: 1.5rem;
    border-radius: 12px;
  }

  .showcase-row:hover {
    transform: translateY(-2px);
  }

  .showcase-images-container {
    flex-direction: column;
    gap: 0.8rem;
  }

  .showcase-image-item {
    max-width: 100%;
  }

  .showcase-img {
    height: 150px;
    border-radius: 8px;
    border-width: 2px;
  }

  .showcase-text-content {
    padding: 1rem;
    border-radius: 8px;
    border-width: 2px;
  }

  .showcase-title {
    font-size: 1.1rem;
    margin-bottom: 0.8rem;
  }

  .showcase-title::after {
    width: 40px;
    height: 2px;
  }

  .showcase-description {
    font-size: 0.9rem;
    line-height: 1.5;
  }

  /* 培训学术板块手机端响应式 */
  .training-academic-section {
    padding: 2rem 0;
  }

  .training-academic-section .section-title {
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
  }

  .training-academic-section .section-title::after {
    width: 50px;
    height: 3px;
  }

  .training-list {
    margin-bottom: 2rem;
  }

  .training-item {
    flex-direction: column;
    text-align: center;
    padding: 1rem;
    margin-bottom: 1.5rem;
    border-radius: 12px;
  }

  .training-item:hover {
    transform: translateY(-2px);
  }

  .training-number {
    align-self: center;
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }

  .training-title {
    font-size: 1rem;
    margin-bottom: 0.6rem;
    text-align: center;
  }

  .training-title::after {
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
  }

  .training-description {
    font-size: 0.9rem;
    line-height: 1.5;
    text-align: left;
  }

  .academic-gallery {
    padding: 1rem;
    border-radius: 12px;
  }

  .gallery-title {
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }

  .gallery-title::after {
    width: 40px;
    height: 2px;
  }

  .gallery-images {
    flex-direction: column;
    gap: 0.8rem;
  }

  .gallery-image-item {
    border-radius: 8px;
  }

  .gallery-img {
    height: 160px;
    border-radius: 8px;
  }

  .image-overlay {
    padding: 1.5rem 1rem 1rem;
  }

  .overlay-text {
    font-size: 1rem;
  }

  /* 专利培训案例板块手机端响应式 */
  .patent-training-section {
    padding: 2rem 0;
  }

  .patent-training-section .section-title {
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
  }

  .patent-training-section .section-title::after {
    width: 50px;
    height: 3px;
  }

  .training-case-content {
    flex-direction: column;
    gap: 1.5rem;
    padding: 1rem;
    border-radius: 12px;
  }

  .training-case-content:hover {
    transform: translateY(-3px);
  }

  .case-image-container {
    max-width: 100%;
    border-radius: 8px;
  }

  .case-img {
    height: 200px;
    border-radius: 8px;
    border-width: 2px;
  }

  .image-decoration {
    width: 40px;
    height: 40px;
    top: -5px;
    right: -5px;
  }

  .image-decoration::before {
    font-size: 0.9rem;
  }

  .case-description {
    font-size: 0.9rem;
    line-height: 1.6;
    padding: 1rem;
    border-radius: 8px;
    border-width: 1px;
  }

  .case-description::before {
    font-size: 2rem;
    top: -5px;
    left: 10px;
  }

  .case-highlights {
    flex-direction: column;
    align-items: center;
    gap: 0.6rem;
  }

  .highlight-item {
    padding: 0.5rem 0.8rem;
    border-radius: 20px;
    width: fit-content;
  }

  .highlight-icon {
    font-size: 1rem;
  }

  .highlight-text {
    font-size: 0.8rem;
  }
}

/* 超小屏幕适配 (360px及以下) */
@media (max-width: 360px) {
  .container {
    width: 100%;
    max-width: 100%;
    padding: 1rem 0.3rem;
    margin: 0;
  }

  .activity-review-section {
    padding: 1.5rem 0;
  }

  .activity-review-section .section-title {
    font-size: 1.4rem;
    margin-bottom: 1.2rem;
  }

  .activity-review-section .section-title::after {
    width: 40px;
    height: 2px;
  }

  .activity-row-single,
  .activity-row-double {
    padding: 0.8rem;
    margin-bottom: 1.2rem;
    border-radius: 10px;
  }

  .single-image-container .activity-img,
  .double-image-item .activity-img {
    width: 240px;
    height: 150px;
    border-radius: 6px;
  }

  .single-text-container .activity-text,
  .double-text-container .activity-text {
    max-width: 260px;
    font-size: 0.85rem;
    line-height: 1.5;
    padding: 0.8rem;
    border-radius: 6px;
  }

  /* 活动展示板块超小屏幕适配 */
  .activity-showcase-section {
    padding: 1.5rem 0;
  }

  .activity-showcase-section .section-title {
    font-size: 1.4rem;
    margin-bottom: 1.2rem;
  }

  .activity-showcase-section .section-title::after {
    width: 40px;
    height: 2px;
  }

  .showcase-row {
    padding: 0.8rem;
    margin-bottom: 1.2rem;
    border-radius: 10px;
  }

  .showcase-img {
    height: 130px;
    border-radius: 6px;
  }

  .showcase-text-content {
    padding: 0.8rem;
    border-radius: 6px;
  }

  .showcase-title {
    font-size: 1rem;
    margin-bottom: 0.6rem;
  }

  .showcase-title::after {
    width: 30px;
    height: 2px;
  }

  .showcase-description {
    font-size: 0.85rem;
    line-height: 1.4;
  }

  /* 培训学术板块超小屏幕适配 */
  .training-academic-section {
    padding: 1.5rem 0;
  }

  .training-academic-section .section-title {
    font-size: 1.4rem;
    margin-bottom: 1.2rem;
  }

  .training-academic-section .section-title::after {
    width: 40px;
    height: 2px;
  }

  .training-list {
    margin-bottom: 1.5rem;
  }

  .training-item {
    padding: 0.8rem;
    margin-bottom: 1.2rem;
    border-radius: 10px;
  }

  .training-number {
    width: 35px;
    height: 35px;
    font-size: 0.9rem;
  }

  .training-title {
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }

  .training-title::after {
    width: 25px;
  }

  .training-description {
    font-size: 0.85rem;
    line-height: 1.4;
  }

  .academic-gallery {
    padding: 0.8rem;
    border-radius: 10px;
  }

  .gallery-title {
    font-size: 1rem;
    margin-bottom: 0.8rem;
  }

  .gallery-title::after {
    width: 30px;
    height: 2px;
  }

  .gallery-images {
    gap: 0.6rem;
  }

  .gallery-image-item {
    border-radius: 6px;
  }

  .gallery-img {
    height: 140px;
    border-radius: 6px;
  }

  .image-overlay {
    padding: 1rem 0.8rem 0.8rem;
  }

  .overlay-text {
    font-size: 0.9rem;
  }

  /* 专利培训案例板块超小屏幕适配 */
  .patent-training-section {
    padding: 1.5rem 0;
  }

  .patent-training-section .section-title {
    font-size: 1.4rem;
    margin-bottom: 1.2rem;
  }

  .patent-training-section .section-title::after {
    width: 40px;
    height: 2px;
  }

  .training-case-content {
    gap: 1rem;
    padding: 0.8rem;
    border-radius: 10px;
  }

  .case-img {
    height: 160px;
    border-radius: 6px;
  }

  .image-decoration {
    width: 35px;
    height: 35px;
    top: -4px;
    right: -4px;
  }

  .image-decoration::before {
    font-size: 0.8rem;
  }

  .case-description {
    font-size: 0.85rem;
    line-height: 1.5;
    padding: 0.8rem;
    border-radius: 6px;
  }

  .case-description::before {
    font-size: 1.8rem;
    top: -4px;
    left: 8px;
  }

  .case-highlights {
    gap: 0.5rem;
  }

  .highlight-item {
    padding: 0.4rem 0.6rem;
    border-radius: 15px;
  }

  .highlight-icon {
    font-size: 0.9rem;
  }

  .highlight-text {
    font-size: 0.75rem;
  }
}

/* 极小屏幕适配 (320px及以下) */
@media (max-width: 320px) {
  .container {
    width: 100%;
    max-width: 100%;
    padding: 0.8rem 0.2rem;
    margin: 0;
  }

  .activity-review-section .section-title {
    font-size: 1.3rem;
  }

  .activity-row-single,
  .activity-row-double {
    padding: 0.6rem;
  }

  .single-image-container .activity-img,
  .double-image-item .activity-img {
    width: 220px;
    height: 140px;
  }

  .single-text-container .activity-text,
  .double-text-container .activity-text {
    max-width: 240px;
    font-size: 0.8rem;
    padding: 0.6rem;
  }

  /* 活动展示板块极小屏幕适配 */
  .activity-showcase-section .section-title {
    font-size: 1.3rem;
  }

  .showcase-row {
    padding: 0.6rem;
  }

  .showcase-img {
    height: 120px;
  }

  .showcase-text-content {
    padding: 0.6rem;
  }

  .showcase-title {
    font-size: 0.95rem;
  }

  .showcase-description {
    font-size: 0.8rem;
  }

  /* 培训学术板块极小屏幕适配 */
  .training-academic-section .section-title {
    font-size: 1.3rem;
  }

  .training-item {
    padding: 0.6rem;
  }

  .training-number {
    width: 32px;
    height: 32px;
    font-size: 0.8rem;
  }

  .training-title {
    font-size: 0.9rem;
  }

  .training-description {
    font-size: 0.8rem;
  }

  .academic-gallery {
    padding: 0.6rem;
  }

  .gallery-title {
    font-size: 0.95rem;
  }

  .gallery-img {
    height: 120px;
  }

  .overlay-text {
    font-size: 0.85rem;
  }

  /* 专利培训案例板块极小屏幕适配 */
  .patent-training-section .section-title {
    font-size: 1.3rem;
  }

  .training-case-content {
    padding: 0.6rem;
  }

  .case-img {
    height: 140px;
  }

  .image-decoration {
    width: 30px;
    height: 30px;
    top: -3px;
    right: -3px;
  }

  .image-decoration::before {
    font-size: 0.7rem;
  }

  .case-description {
    font-size: 0.8rem;
    padding: 0.6rem;
  }

  .case-description::before {
    font-size: 1.5rem;
  }

  .highlight-item {
    padding: 0.3rem 0.5rem;
  }

  .highlight-icon {
    font-size: 0.8rem;
  }

  .highlight-text {
    font-size: 0.7rem;
  }
}
</style>